import React from "react";
import styles from "../styles.scss";
import IconComponent from "../../../../../components/commons/IconComponent";

function NumberInput({value, onChange, unit, invalid}) {
    const _onChange = e => {
        const _value = onChange(Number(e.target.value.replace(/\D/g, "") || 0));
        if (_value >= 0) {
            onChange(_value);
        }
    };

    const onClick = number => {
        const _value = value + number;
        if (_value >= 0) {
            onChange(_value);
        }
    };


    return (
        <div className={`${styles.number} ${invalid && styles.invalid}`}>
            <input type="text" placeholder="0" value={value || ""} onChange={_onChange}/>
            <div className={styles.unit}>{unit}</div>
            <div className={styles.stepper}>
                <div className={styles.step} onClick={() => onClick(1)}>
                    <IconComponent icon="top-custom-size-icon"/>
                </div>
                <div className={styles.step} onClick={() => onClick(-1)}>
                    <IconComponent icon="botton-custom-size-icon"/>
                </div>
            </div>
        </div>
    );
}

export default NumberInput;


// WEBPACK FOOTER //
// ./src/pages/Dashboard/components/MagazineCustomSizeModal/components/NumberInput.js